import RoomList from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/pages/list/roomlist';
import EffectData from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/pages/list/effectdata';
import FlowData from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/pages/list/flowdata';
import data from '../constants/data';
import { getQuery } from '@/common/utils';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import ManagerPending from '../../merchants/venue-detail/micro-app-pages/manager-pending';

export default [
  {
    // /channel-service/activity/collection-pool-list/pools/roomlist?entry=0管理者 | 1参与者&areaId=1&activityId=&planCode=
    title: getQuery('viewCheck') === '0' ? '视觉审核收品池列表' : '收品池列表',
    path: '/roomlist',
    component: () => (
      <ContextProviderMenus.Consumer>
        {(value) => {
          return (
            <RoomList
              performanceApi={true}
              data={{
                ...data,
                canPerformanace: value.canPerformance,
                canPerformance: value.canPerformance,
              }}
            />
          );
        }}
      </ContextProviderMenus.Consumer>
    ),
  },
  {
    // /channel-service/activity/collection-pool-list/pools/effectdata?entry=0管理者 | 1参与者&areaId=1&activityId=&planCode=
    title: '效果数据',
    path: '/effectdata',
    component: () => (
      <ContextProviderMenus.Consumer>
        {(value) => {
          return (
            <EffectData
              data={{
                ...data,
                canPerformanace: value.canPerformance,
                canPerformance: value.canPerformance,
              }}
            />
          );
        }}
      </ContextProviderMenus.Consumer>
    ),
  },
  {
    // /channel-service/activity/collection-pool-list/pools/manage/activityData/detail?id=&userType=1报名用户 | 2 管理员&planCode=
    title: '流程数据',
    // /manage/activityData/detail?id=10606405&userType=1&activityStatus=1
    // /mamage/activityData 是流程数据路由
    path: '/manage/*',
    getLink({ parentPath, search }) {
      return parentPath + '/manage/activityData/detail' + search;
    },
    component: () => <FlowData data={data} />,
  },
];
